import { Injector } from '@angular/core';
import { MEDIA_UPLOAD_PROTOCOL_ID, MediaAssetProvidersBaseService } from '@common/media/shared';
import { FeatureProvidersRegistry } from '@core/shared/feature';
import { ProtocolDistributor } from '@core/shared/protocol';
import { sharedInjectorForFrontend } from '@core/frontend-shared/providers';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/feature";
import * as i2 from "@core/shared/protocol";
export let MediaAssetProvidersFrontendService = /*#__PURE__*/(() => {
  class MediaAssetProvidersFrontendService extends MediaAssetProvidersBaseService {
    constructor(providersRegistry, protocol, injector) {
      super(providersRegistry, protocol, sharedInjectorForFrontend(injector));
      this.protocol = protocol;
    }
    static {
      this.ɵfac = function MediaAssetProvidersFrontendService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MediaAssetProvidersFrontendService)(i0.ɵɵinject(i1.FeatureProvidersRegistry), i0.ɵɵinject(MEDIA_UPLOAD_PROTOCOL_ID), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MediaAssetProvidersFrontendService,
        factory: MediaAssetProvidersFrontendService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MediaAssetProvidersFrontendService;
})();